import { EMAIL_REGEX } from "./constants";

export function isEmailValid(email: string): RegExpMatchArray | null {
  return email.toLowerCase().match(EMAIL_REGEX);
}
